import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import useMutationCreateRank from '@/modules/manage-rank/api/hooks/useMutateCreateRank'
import useMutationUpdateRankUpRewards from '@/modules/manage-rank/api/hooks/useMutationUpdateRankUpRewards'
import { CreateRankRequest } from '@/modules/manage-rank/type'
import RankForm from '../../../RankForm'
import { z } from 'zod'
import { createRankFormSchema } from '../../../RankForm/components'

type RankFormValues = z.infer<typeof createRankFormSchema>

export default function CreateRankForm() {
	const navigate = useNavigate()

	const { mutateAsync: createRank } = useMutationCreateRank()
	const { mutateAsync: updateRankUpRewards } = useMutationUpdateRankUpRewards()

	const handleSubmit = async (values: RankFormValues) => {
		try {
			const {
				rankUpRewards,
				allowRepeatRankUpRewards,
				dailyCheckInId,
				...rankData
			} = values

			const created = await createRank({
				payload: {
					...(rankData as Omit<CreateRankRequest, 'dailyCheckInSettingId'>),
					dailyCheckInSettingId: dailyCheckInId ?? undefined,
					allowRepeatRankUpRewards,
				},
			})

			if (rankUpRewards && rankUpRewards.length > 0) {
				await updateRankUpRewards({
					id: created.id,
					payload: {
						rewards: rankUpRewards.map((r) => ({
							type: r.type,
							amount: r.amount,
							luckyWheelSettingId: r.luckyWheelSettingId ?? undefined,
							gameId: r.gameId ?? undefined,
							betAmount: r.betAmount ?? undefined,
							presetId: r.presetId ?? undefined,
						})),
					},
				})
			}

			toast.success('สร้าง Rank สำเร็จ')
			navigate('/operator/rank')
		} catch (error) {
			showErrorToast(
				error instanceof Error ? error : 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
			)
		}
	}

	return <RankForm mode="create" onSubmit={handleSubmit} />
}
